import { NumberValue, VALUE_TYPE } from "Components/NumberValue";
import {
  NeedName,
  ProductCoverageName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";

import { PRESENTATION } from "Components/NumberValue/styled";
import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import { sum } from "Utils/arrayUtils";
import React from "react";
import { PriceLoadingWrapper } from "../../../ProductPrice/AdviceCards/styled";
import { usePriceFromAkaAdvice } from "../hooks/usePriceFromAkaAdvice";
import { PriceWrapper } from "../styled";
import { getMonthlyPrice } from "../utils";

interface Props {
  needName: NeedName;
  productCoverages: ProductCoverageName[];
  priceIsChanging?: boolean;
  priceIsLoading?: boolean;
}

export const InsurancePrice = ({
  needName,
  productCoverages,
  priceIsChanging = false,
  priceIsLoading = false,
}: Props): React.ReactElement => {
  const prices = usePriceFromAkaAdvice(needName);
  const price = productCoverages
    .map((productCoverageName) => getMonthlyPrice(productCoverageName, prices))
    .reduce(sum, 0);

  return (
    <PriceWrapper className="AkaAdviceInsurancePrice">
      <Price
        price={price}
        isChanging={priceIsChanging}
        loading={priceIsLoading}
      />
    </PriceWrapper>
  );
};

export const Price = (props: {
  loading: boolean;
  price: number;
  isChanging: boolean;
  presentation?: PRESENTATION;
}): React.ReactElement | null => {
  if (props.price > 0 && props.loading) {
    return (
      <PriceLoadingWrapper>
        <ThemedSpinner id="ValueSpinner" black size="small" />
        <span className="ValueType">{VALUE_TYPE.NOK_MONTH}</span>
      </PriceLoadingWrapper>
    );
  }

  if (props.price === 0) {
    return null;
  }

  return (
    <NumberValue
      as="p"
      className="InsuranceMonthlyPrice"
      value={props.price}
      type={VALUE_TYPE.NOK_MONTH}
      boldValue
      largeValue
      disabledColor={props.isChanging}
      presentation={props.presentation}
    />
  );
};
